const FOCUSABLE_SELECTOR = [
    'input:not([type="hidden"]):not([disabled]):not([readonly])',
    "select:not([disabled])",
    "textarea:not([disabled])",
].join(", ");

function isFocusableField(element: HTMLElement): boolean {
    if (element.tabIndex === -1) return false;
    if (element.closest('[aria-hidden="true"]')) return false;

    const style = window.getComputedStyle(element);
    if (style.display === "none" || style.visibility === "hidden") return false;

    return true;
}

/** Focus the first visible, enabled input/select/textarea within a form container. */
export function focusFirstFormField(container: HTMLElement | null | undefined): void {
    if (!container) return;

    const fields = container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR);
    for (const field of fields) {
        if (!isFocusableField(field)) continue;
        field.focus({ preventScroll: true });
        return;
    }
}
